
import { asyncApiPosition } from './geo-location';
import { log } from './debug';

const getDemoAppLocation=async (location,params)=>{
    let newLocation = {...location}
    log.message('getDemoAppLocation','params', params);
    const isDemo=params.isDemo; 
    const phone=params.phone; 
    const clientInfo=params.clientInfo; 
    const deliveryRates=params.deliveryRates; 
    const payMethods=params.payMethods

    newLocation.takeorder = {
                        ... newLocation.takeorder, 
                        isDemo:isDemo, 
                        whatsapp:{
                                phone:phone,
                                active:true,
                                }
                        }

        
    if(deliveryRates){
        if(!hasAddressGeo(newLocation)){
            newLocation = await getLocationWithPlace(newLocation);  
        }
        newLocation.takeorder.deliveryRates={
            active: true,
            price: 1,
            radius: 40,
            }
    }

    if(clientInfo){
        newLocation.takeorder.clientInfo={
                name: true,
                phone: false,
                active: true,
                message: true
        }
    }

    
    if(payMethods){
        newLocation.takeorder.paymentOptions= {
            active: true,
            payMethods: [
                {
                    "id": "CASH",
                    "paymentInfo": {
                      "cashChange": true
                    }
                },
                {"id": "CARD"},
                {"id": "PIX"},
                {"id": "BIZUM"},
                {"id": "BANK_TRANSFER",},
                {"id": "PAYMENT_LINK",},
                ]
         }
    }
        
    
     return newLocation;   
    }

   
    const hasAddressGeo=(location)=>{
        if(!location) return false; 
        if(!location.latitude || !location.longitude) return false
        const lat =  Math.abs(location.latitude); 
        const lon = Math.abs(location.longitude);
        return lat>0.0 && lon>0.0 
    }


const getDemowebLocation= async (location)=>{
    const newLocation = getLocationWithPlace(location);
    newLocation.name = `DEMO ${ newLocation.name}`;
    log.message("getDemowebLocation","demoLocation", newLocation);
    return  newLocation;
}


const getLocationWithPlace =  async (fetchLocation)=>{
    const location = {... fetchLocation}; 
    const result =  await asyncApiPosition();
    if(!result) return location;

    const address = `DEMO ${result.data.city}`; 
    const geopoint = {
        latitude:result.data.latitude, 
        longitude:result.data.longitude,
    }
    location.latitude = geopoint.latitude; 
    location.longitude= geopoint.longitude; 
    location.address= address; 
    location.place = {
        address: address, 
        details: 'DEMO', 
        geopoint:geopoint, 
    }
    log.message("getDemowebLocation","demoLocation",location); 
    return location;
}


export {
    getDemowebLocation,
    getDemoAppLocation
}